import { render, staticRenderFns } from "./PeriodicTable.vue?vue&type=template&id=4fd08035&scoped=true"
import script from "./PeriodicTable.vue?vue&type=script&lang=js"
export * from "./PeriodicTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodicTable.vue?vue&type=style&index=0&id=4fd08035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd08035",
  null
  
)

export default component.exports